import { apiClient } from './api';
import type { ApiResponse } from '@/types';

export interface SendTextRequest {
  to: string;
  type: 'text';
  text: string;
  channel_id?: string;
  idempotency_key?: string;
  source_system?: string;
  source_type?: string;
  source_id?: string;
}

export interface SendTemplateRequest {
  to: string;
  type: 'template';
  channel_id?: string;
  idempotency_key?: string;
  source_system?: string;
  source_type?: string;
  source_id?: string;
  template: {
    template_id: string;
    language: string;
    variables?: Record<string, string>;
  };
}

export type SendMessageResponse = {
  queued: boolean;
  message_id?: string;
  status: string;
};

export async function sendTextMessage(payload: SendTextRequest): Promise<ApiResponse<SendMessageResponse>> {
  return apiClient.post<SendMessageResponse>('/messages/send', payload);
}

export async function sendTemplateMessage(payload: SendTemplateRequest): Promise<ApiResponse<SendMessageResponse>> {
  return apiClient.post<SendMessageResponse>('/messages/send', payload);
}
